import { ReactElement, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";

import { Grid } from "@mui/material";
import Checkboxes, { TForm } from "./Checkboxes";
import {
  QPFQuickRegisterForm,
  QPJQuickRegisterForm,
  useFormContext,
} from "@4uhub/lib4uhub";

import { buildTPath } from "../../../advantages-and-benefits-club.utils";

const EntitySelect = (): ReactElement => {
  const { t } = useTranslation();
  const { control, setValue, getValues } = useFormContext<TForm>();
  const entityType = useWatch({ control, name: "entity", defaultValue: "QPF" });

  const individualStipulant = useWatch({
    control,
    name: "individualStipulant",
  });
  const legalStipulantSchema = useWatch({
    control,
    name: "legalEntityStipulant",
  });

  useEffect(() => {
    if (getValues("contractTitle")) return;

    const title =
      individualStipulant?.individualName ||
      legalStipulantSchema?.corporateName;

    if (title) setValue("contractTitle", title);
  }, [individualStipulant, legalStipulantSchema, setValue, getValues]);

  return (
    <>
      <Checkboxes />

      <Grid item xs={12} sm={7}>
        {entityType === "QPF" && (
          <QPFQuickRegisterForm
            label={t(buildTPath("individual_person"))}
            name="individualStipulant"
          />
        )}

        {entityType === "QPJ" && (
          <QPJQuickRegisterForm
            label={t(buildTPath("legal_entity"))}
            name="legalEntityStipulant"
          />
        )}
      </Grid>
    </>
  );
};

export default EntitySelect;
